module.exports = __webpack_public_path__ + "img/mgp.ba825f9d.jpg";